module.exports = "../images/icons/admin/icon-delete.svg";